import { useMutation } from '@tanstack/react-query';
import { feedbackService } from 'shared/src/api';

export const useSaveFeedback = () => {
  return useMutation({
    mutationFn: feedbackService.saveFeedback,
  });
};
